var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 8.99836C6.67157 8.99836 6 8.32678 6 7.49836V6.00491C4.34314 6.00491 3 7.34805 3 9.00491V11.0049H23V9.00491C23 7.34805 21.6568 6.00491 20 6.00491V7.50495C20 8.33337 19.3284 9.00495 18.5 9.00495C17.6716 9.00495 17 8.33337 17 7.50495V6.00491H9V7.49836C9 8.32678 8.32843 8.99836 7.5 8.99836ZM17 3.00491H9V1.5C9 0.671573 8.32843 0 7.5 0C6.67157 0 6 0.671573 6 1.5V3.00491C2.68629 3.00491 0 5.6912 0 9.00491V21.0049C0 24.3186 2.68629 27.0049 6 27.0049H20C23.3137 27.0049 26 24.3186 26 21.0049V9.00491C26 5.6912 23.3137 3.00491 20 3.00491V1.50491C20 0.676483 19.3284 0.00490998 18.5 0.00490999C17.6716 0.00491 17 0.676483 17 1.50491V3.00491ZM3 14.0049V21.0049C3 22.6618 4.34314 24.0049 6 24.0049H20C21.6568 24.0049 23 22.6618 23 21.0049V14.0049H3Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsIcon);
export default __webpack_public_path__ + "static/media/eventsIcon.a6023cd64e81495250c7f17abc958834.svg";
export { ForwardRef as ReactComponent };